import React from 'react';
import ChatMessage from '../../chat/ChatMessage';
import Card from '../../common/Card';

/**
 * The AI-written recommendations at the end of a student's report.
 */
export default function StudentReportRecommendationsCard({ recommendations }) {
    if (!recommendations || !String(recommendations).trim()) return null;

    return (
        <Card title="Recommendations">
            <ChatMessage
                message={{
                    id: 'student-general-recommendations',
                    content: String(recommendations),
                    role: 'assistant'
                }}
                fullWidth
                isPlain
                showPdfExport={false}
            />
        </Card>
    );
}
